module.exports = __webpack_public_path__ + "img/5.ceb6d3b0.png";